// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileIcon__icon-e624a5 {
  flex-shrink: 0;
  vertical-align: middle;
  fill: currentColor;
  width: 48px;
  height: 48px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/FileIcon/FileIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF","sourcesContent":[".icon {\n  flex-shrink: 0;\n  vertical-align: middle;\n  fill: currentColor;\n  width: 48px;\n  height: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `FileIcon__icon-e624a5`
};
module.exports = ___CSS_LOADER_EXPORT___;
